<div class="d-flex flex-wrap flex-stack mb-6">
  <h3 class="fw-bold my-2">My events</h3>
  <div class="d-flex flex-wrap my-2">
    <app-button
      [variant]="'primary'"
      [label]="'Add Event'"
      [iconClass]="'fa fa-plus'"
      (clicked)="openAddEvent()"
    />
  </div>
</div>
<div class="row g-6 mb-6 g-xl-9 mb-xl-9" [class.opacity-50]="loading" [class.pointer-events-none]="loading">
  @for (event of events; track event.event_id) {
    <div class="col-md-4">
      <app-event-card
        [event]="event"
      />
    </div>
  }
  @if (!loading && (!events || events.length === 0)) {
    <div class="col-12 text-center text-muted py-10">No events found.</div>
  }
</div>
